import { Locales } from '@monoimin/sb-types';
import { locales } from '@monoimin/constants';

export type ExpertsDict = Awaited<
  ReturnType<(typeof expertsDictByLocale)[Locales]>
>;

const expertsDictByLocale = {
  ru: () => import(`./ru.json`).then((module) => module.default),
  en: () => import(`./en.json`).then((module) => module.default),
  de: () => import(`./en.json`).then((module) => module.default),
  tr: () => import(`./tr.json`).then((module) => module.default),
  es: () => import(`./es.json`).then((module) => module.default),
};

export async function getExpertsDict(
  locale: Locales = 'en'
): Promise<ExpertsDict> {
  if (!locales.includes(locale)) {
    locale = 'en';
  }
  return await expertsDictByLocale[locale]();
}
